.item {
  flex-shrink: 0;
  width: 140px;
}

.item2015 {
  flex-shrink: 0;
  width: 140px; /* Default width */
}

.button {
  display: grid;
  place-items: center;
  width: 100%;
  height: 100%;
}

.img {
  max-width: 100%;
  max-height: 100%;
  overflow: hidden;
  object-fit: contain;

  &:hover {
    opacity: 0.8;
  }
}

@keyframes fade-in {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

.overlay {
  position: fixed;
  inset: 0;
  z-index: 30;
  background-color: rgb(0 0 0 / 5%);
  animation: fade-in 0.1s ease-in-out;
}

.content {
  position: fixed;
  top: 50%;
  left: 50%;
  z-index: 30;

  /* 画像はFastlyで最大サイズを1440px×960pxにしているので、max-width,max-heightをFastlyの画像サイズ/2+padding分にに合わせる */
  max-width: calc(720px + 40px);
  max-height: calc(480px + 40px);
  padding: 20px;
  background-color: #fff;
  border-radius: 8px;
  transform: translate(-50%, -50%);
  animation: fade-in 0.1s ease-in-out;

  @media screen and (width <= 760px) {
    width: max-content;
    max-width: calc(90vw - 20px);
  }

  @media screen and (height <= 520px) {
    max-height: calc(90vh - 20px);
  }
}

.contentBody {
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100%;
  max-height: 480px;

  @media screen and (height <= 520px) {
    max-height: calc(90vh - 60px);
  }
}

.contentImage {
  display: block;
  flex: 1;
  width: auto;
  max-height: 480px;
  object-fit: scale-down;

  @media screen and (height <= 520px) {
    max-height: calc(90vh - 60px);
  }
}

.closeButton {
  position: absolute;
  top: -40px;
  right: -40px;
  width: 40px;
  height: 40px;
  padding: 12px;
  background-color: #000;
  border-radius: 100%;

  &:hover {
    background-color: rgb(77 77 77);
  }
}

@container press-release-root (min-width: 1024px) {
  .pressReleaseRoot {
    width: 178px;
  }

  .item2015 {
    width: 172px;
  }
}

@media screen and (width >= 1024px) {
  .screen {
    width: 178px;
  }

  .item2015 {
    width: 172px;
  }
}
